{
  "id": "campaign-003",
  "name": "Dewy Field",
  "seed": "campaign:3",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [".......", ".#.....", "_______", ".......", ".......", ".......", "#.....S"],
  "critters": [],
  "pickups": [
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 3
    }
  ],
  "generatorVersion": 3,
  "level": 3,
  "biome": "backyard",
  "par": {
    "reel": 1290,
    "push": 1170,
    "selfPropelled": 1080,
    "tractor": 1040,
    "zeroTurn": 731,
    "fairway": 484
  },
  "routeTries": {
    "par": {
      "reel": 16,
      "push": 10,
      "selfPropelled": 10,
      "tractor": 12,
      "zeroTurn": 1,
      "fairway": 4
    }
  }
}
